import { LineChart } from "@mui/x-charts/LineChart";
import { chartColors } from "../../../../Config/Colors";

const pad = (n) => String(n).padStart(2, "0");
const timeText = (d) =>
  `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

// Fincan/değirmen: ham fark + eşik (kesikli).
export const DEFAULT_SERIES = [
  { id: "value", key: "value", label: "Değer", color: chartColors.sensorValue },
  {
    id: "threshold",
    key: "threshold",
    label: "Eşik",
    color: chartColors.sensorThreshold,
    dashed: true,
  },
];

/**
 * Seçili sensörün son kayıtları — zaman ekseninde çizgiler.
 * @param {object} props
 * @param {{ at: number }[]} props.points her nokta, serilerin `key` alanlarını taşır
 * @param {{ id: string, key: string, label: string, color: string,
 *   dashed?: boolean }[]} [props.series] çizgiler (varsayılan: değer + eşik)
 * @param {{ min?: number, max?: number }} [props.yRange] sabit dikey aralık
 */
export default function SensorHistoryChart({
  points,
  series = DEFAULT_SERIES,
  yRange,
}) {
  const dashed = Object.fromEntries(
    series
      .filter((s) => s.dashed)
      .map((s) => [
        `& .MuiLineElement-series-${s.id}`,
        { strokeDasharray: "5 4" },
      ]),
  );
  return (
    <LineChart
      height={190}
      margin={{ top: 30, right: 12, bottom: 28, left: 48 }}
      skipAnimation
      xAxis={[
        {
          data: points.map((p) => new Date(p.at)),
          scaleType: "time",
          valueFormatter: (d) => timeText(d),
          tickNumber: 4,
        },
      ]}
      {...(yRange ? { yAxis: [{ ...yRange }] } : {})}
      series={series.map((s) => ({
        id: s.id,
        label: s.label,
        data: points.map((p) => p[s.key] ?? null),
        color: s.color,
        showMark: false,
        connectNulls: false,
      }))}
      slotProps={{
        legend: {
          itemMarkHeight: 8,
          itemMarkWidth: 12,
          labelStyle: { fontSize: 11 },
        },
      }}
      sx={{
        ...dashed,
        "& .MuiChartsAxis-tickLabel": { fontSize: 10 },
      }}
    />
  );
}
